// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"201":"9f7805074228c0d4","1424":"4e808d895c7bb6c6","6137":"4d020f46703eef7e","7767":"a69232874d66db99","7769":"ebdc2f829d679a47"}[chunkId] + ".css";
};